import React, { Component } from "react";

import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";

import { toast } from "react-toastify";

import DataTable from "react-data-table-component";

import configData from "../config.json";



import LoadingOverlay from "./LoadingOverlay";
export default class Rulesdef extends Component {

  constructor(props) {

    super(props);

    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",

      show: false,

      data: [],

      sId: sessionStorage.getItem("sessionId"),

      uId: sessionStorage.getItem("uId"),

      errors: {},

      filteredData: null,

      tableClms: [

        {

          name: "S.NO",

          selector: (row, i) => row.rulesdef_Id,

          sortable: true,

          cell: (row) => <span>{row.rulesdef_Id}</span>,

        },

        {

          name: "Rule Group Id",

          selector: (row, i) => row.rulegroupId,

          sortable: true,

          cell: (row) => <span>{row.rulegroupId}</span>,

        },

        {

          name: "Name",

          selector: (row, i) => row.name,

          sortable: true,

          cell: (row) => <span>{row.name}</span>,

        },

        {

          name: "Description",

          selector: (row, i) => row.description,

          sortable: true,

          cell: (row) => <span>{row.description}</span>,

        },

        {

          name: "Is Active",

          selector: (row, i) => row.isActive,

          sortable: true,

          cell: (row) => <span>{row.isActive}</span>,

        },

        {

          name: "Priority",

          selector: (row, i) => row.priority,

          sortable: true,

          cell: (row) => <span>{row.priority}</span>,

        },

        {

          name: "Execution Order",

          selector: (row, i) => row.executionOrder,

          sortable: true,

          cell: (row) => <span>{row.executionOrder}</span>,

        },

        {

          name: "Condition Logic Id",

          selector: (row, i) => row.conditionlogicId,

          sortable: true,

          cell: (row) => <span>{row.conditionlogicId}</span>,

        },

        {

          name: "Version",

          selector: (row, i) => row.version,

          sortable: true,

          cell: (row) => <span>{row.version}</span>,

        },

        {

          name: "rule inputparameters",

          selector: (row, i) => row.ruleinputparameters,

          sortable: true,

          cell: (row) => <span>{row.ruleinputparameters}</span>,

        },

        {

          name: "ruleoutputparameters",

          selector: (row, i) => row.ruleoutputparameters,

          sortable: true,

          cell: (row) => <span>{row.ruleoutputparameters}</span>,

        },



        { name: "Is Active", selector: (row, i) => row.is_active, sortable: true, cell: (row) => <span>{row.is_active}</span>, },//***tableClms

        {

          name: "Actions",

          sortable: false,

          cell: (row) => (

            <div>

              {/* edit button and delete button */}

              <Button

                style={{ marginRight: "10px" }}

                variant="primary"

                onClick={() => this.RulesdefeditHandler(row)}

                className="bi bi-pen"

              ></Button>

              <Button

                variant="danger"

                onClick={() => this.handleDelete(row)}

                className="bi bi-trash danger"

              ></Button>

            </div>

          ),

        },

      ],

      currentPage: 1,

      itemsPerPage: 10,

      isEditing: false,

      rulesdef_Id: "",

      rulegroupId: "",

      name: "",

      description: "",

      isActive: "",

      priority: "",

      executionOrder: "",

      conditionlogicId: "",

      version: "",

      ruleinputparameters: "",

      ruleoutputparameters: "",

      dummyOne: "",

      dummyTwo: "",

      dummyThree: "",

      dummyFour: "",

      dummyFive: "",

      yes_no: [], is_active: '',//***state

    };

  }

  // offcanvas Open

  handleOffcanvasShow = () => {

    this.setState({

      show: true,

      rulegroupId: "",

      name: "",

      description: "",

      isActive: "",

      priority: "",

      executionOrder: "",

      conditionlogicId: "",

      version: "",

      dummyOne: "",

      dummyTwo: "",

      dummyThree: "",

      dummyFour: "",

      dummyFive: "",

    });

  };

  // Offcanvas close button

  handleOffcanvasClose = () => {

    this.setState({

      show: false,

      isEditing: false,

      rulegroupId: "",

      name: "",

      description: "",

      isActive: "",

      priority: "",

      executionOrder: "",

      conditionlogicId: "",

      version: "",

      dummyOne: "",

      dummyTwo: "",

      dummyThree: "",

      dummyFour: "",

      dummyFive: "",

    });

  };

  showToast = (msg, type) => {

    switch (type) {

      case "success":

        toast.success(msg);

        break;

      case "error":

        toast.error(msg);

        break;

      case "warning":

        toast.warn(msg); // 'warn' is used instead of 'warning'

        break;

      default:

        toast.info(msg);

    }

  };

  RulesdefeditHandler = (row) => {

    // e.preventDefault();

    this.setState({

      isEditing: true,

      rulesdef_Id: row.rulesdef_Id,

      rulegroupId: row.rulegroupId,

      name: row.name,

      description: row.description,

      isActive: row.isActive,

      priority: row.priority,

      executionOrder: row.executionOrder,

      conditionlogicId: row.conditionlogicId,

      version: row.version,

      dummyOne: row.dummyOne,

      dummyTwo: row.dummyTwo,

      dummyThree: row.dummyThree,

      dummyFour: row.dummyFour,

      dummyFive: row.dummyFive, yes_no: [], is_active: row.is_active,//***editstate

    });

  };



  RulesdeffetchHandler = () => {

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Rulesdef/list", {

      // Enter your IP address here



      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header

    })

      .then((response) => response.json())

      .then((data) => {

        if (data.status === "success") {

          this.setState({ data: data.list });

        }

      });

  };

  RulesdefsubmitHandler = (e) => {

    e.preventDefault();

    //   setButtons(contacts);

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("rulegroupId", this.state.rulegroupId);

    formData.append("name", this.state.name);

    formData.append("description", this.state.description);

    formData.append("isActive", this.state.isActive);

    formData.append("priority", this.state.priority);

    formData.append("executionOrder", this.state.executionOrder);

    formData.append("conditionlogicId", this.state.conditionlogicId);

    formData.append("version", this.state.version);

    formData.append("dummyOne", this.state.dummyOne);

    formData.append("dummyTwo", this.state.dummyTwo);

    formData.append("dummyThree", this.state.dummyThree);

    formData.append("dummyFour", this.state.dummyFour);

    formData.append("dummyFive", this.state.dummyFive);



    formData.append('is_active', this.state.is_active);
    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Rulesdef/add", {

      // Enter your IP address here



      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header

    })

      .then((response) => response.json())

      .then((data) => {

        this.showToast(data.message, data.status);

        if (data.status === "success") {

          this.RulesdeffetchHandler();

          this.handleOffcanvasClose();

          this.setState({

            rulegroupId: "",

            name: "",

            description: "",

            isActive: "",

            priority: "",

            executionOrder: "",

            conditionlogicId: "",

            version: "",

            dummyOne: "",

            dummyTwo: "",

            dummyThree: "",

            dummyFour: "",

            dummyFive: "",

          });

        }

      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });

  };

  RulesdefupdateHandler = (e) => {

    e.preventDefault();

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("rulesdef_Id", this.state.rulesdef_Id);

    formData.append("rulegroupId", this.state.rulegroupId);

    formData.append("name", this.state.name);

    formData.append("description", this.state.description);

    formData.append("isActive", this.state.isActive);

    formData.append("priority", this.state.priority);

    formData.append("executionOrder", this.state.executionOrder);

    formData.append("conditionlogicId", this.state.conditionlogicId);

    formData.append("version", this.state.version);

    formData.append("dummyOne", this.state.dummyOne);

    formData.append("dummyTwo", this.state.dummyTwo);

    formData.append("dummyThree", this.state.dummyThree);

    formData.append("dummyFour", this.state.dummyFour);

    formData.append("dummyFive", this.state.dummyFive);



    formData.append('is_active', this.state.is_active);
    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Rulesdef/update", {

      method: "POST",

      mode: "cors",

      body: formData,

    })

      .then((response) => response.json())

      .then((data) => {

        this.showToast(data.message, data.status);

        if (data.status === "success") {

          this.RulesdeffetchHandler();

          this.handleOffcanvasClose();

        }

      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });

  };



  componentDidMount() {

    this.RulesdeffetchHandler();



    this.yes_nofetchHandler();
    //***componentDidMount

  }

  handlerulegroupIdChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ rulegroupId: fieldValue });

  };

  handlenameChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ name: fieldValue });

  };

  handledescriptionChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ description: fieldValue });

  };

  handleisActiveChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ isActive: fieldValue });

  };

  handlepriorityChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ priority: fieldValue });

  };

  handleexecutionOrderChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ executionOrder: fieldValue });

  };

  handleconditionlogicIdChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ conditionlogicId: fieldValue });

  };

  handleversionChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ version: fieldValue });

  };

  handledummyOneChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyOne: fieldValue });

  };

  handledummyTwoChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyTwo: fieldValue });

  };

  handledummyThreeChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyThree: fieldValue });

  };

  handledummyFourChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyFour: fieldValue });

  };

  handledummyFiveChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyFive: fieldValue });

  };

  handleis_activeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ is_active: fieldValue });
  }; yes_nofetchHandler = () => {
    fetch(configData.api_url + "C_Yes_no/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ yes_no: data.list });
        }
      });
  };//***inputFunctions

  handleRowSelect = (row) => {

    this.setState({

      selectedRow: row.index,

    });

  };

  handleRowUpdate = (newData, oldData) => {

    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });

  };



  handleEdit = (row) => {

    console.log(`Editing row with ID ${row.id}`);

    // implement your edit logic here

  };

  handleDelete = (row, index) => {

    var formData = new FormData();

    formData.append("rulesdef_Id", row.rulesdef_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Rulesdef/delete", {

      method: "POST",

      mode: "cors",

      body: formData,

    })

      .then((response) => response.json())

      .then((data) => {

        this.showToast(data.message, data.status);

        if (data.status === "success") {

          this.RulesdeffetchHandler();

        }

      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });

  };

  handlePageChange = (page) => {

    this.setState({ currentPage: page });

  };



  handlePerRowsChange = (newPerPage, page) => {

    this.setState({ itemsPerPage: newPerPage, currentPage: page });

  };



  handleFilter = (e) => {

    const searchValue = e.target.value.toLowerCase();

    const filteredData = this.state.data.filter((row) => {

      return Object.values(row).join(" ").toLowerCase().includes(searchValue);

    });

    this.setState({ filteredData });

  };



  render() {

    const paginatedData = this.state.filteredData

      ? this.state.filteredData.slice(

        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage

      )

      : this.state.data.slice(

        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage

      );



    return (

      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />

        <div className="row">

          <div className="col-md-12 col-sm-12 col-xs-12">

            <div className="x_panel">

              <div className="x_content">

                <div

                  id="datatable_wrapper"

                  className="dataTables_wrapper form-inline

                dt-bootstrap no-footer"

                >

                  <Row className="row">

                    <div>

                      <h3

                        className="logoskybluecolor"

                        style={{ textAlign: "start" }}

                      >

                        Rules Def

                      </h3>

                    </div>

                    <Col

                      className="d-flex justify-content-end"

                      style={{ marginRight: "5px", marginTop: "20px" }}

                    >

                      <Offcanvas

                        show={this.state.show}

                        onHide={this.handleOffcanvasClose}

                        {...this.props}

                        style={{ width: "500px" }}

                        placement="end"

                        backdrop="true"

                      >

                        <Offcanvas.Header closeButton>

                          <Offcanvas.Title>Add Rulesdef</Offcanvas.Title>

                        </Offcanvas.Header>

                        <Offcanvas.Body>

                          <Container

                            style={{ overflowY: "auto", height: "auto" }}

                          >

                            <Row className="divstyle">

                              <Row>

                                <Form>

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Rule Group Id

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handlerulegroupIdChange}

                                        className="form-control"

                                        name="rulegroupId"

                                        value={this.state.rulegroupId}

                                        required="required"

                                        placeholder="Enter Rule Group Id"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.rulegroupId}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Name

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handlenameChange}

                                        className="form-control"

                                        name="name"

                                        value={this.state.name}

                                        required="required"

                                        placeholder="Enter Name"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.name}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Description

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handledescriptionChange}

                                        className="form-control"

                                        name="description"

                                        value={this.state.description}

                                        required="required"

                                        placeholder="Enter Description"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.description}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Is Active

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handleisActiveChange}

                                        className="form-control"

                                        name="isActive"

                                        value={this.state.isActive}

                                        required="required"

                                        placeholder="Enter Is Active"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.isActive}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Priority

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handlepriorityChange}

                                        className="form-control"

                                        name="priority"

                                        value={this.state.priority}

                                        required="required"

                                        placeholder="Enter Priority"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.priority}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Execution Order

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={

                                          this.handleexecutionOrderChange

                                        }

                                        className="form-control"

                                        name="executionOrder"

                                        value={this.state.executionOrder}

                                        required="required"

                                        placeholder="Enter Execution Order"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.executionOrder}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Condition Logic Id

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={

                                          this.handleconditionlogicIdChange

                                        }

                                        className="form-control"

                                        name="conditionlogicId"

                                        value={this.state.conditionlogicId}

                                        required="required"

                                        placeholder="Enter Condition Logic Id"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.conditionlogicId}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Version

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handleversionChange}

                                        className="form-control"

                                        name="version"

                                        value={this.state.version}

                                        required="required"

                                        placeholder="Enter Version"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.version}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Dummy One

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handledummyOneChange}

                                        className="form-control"

                                        name="dummyOne"

                                        value={this.state.dummyOne}

                                        required="required"

                                        placeholder="Enter Dummy One"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.dummyOne}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Dummy Two

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handledummyTwoChange}

                                        className="form-control"

                                        name="dummyTwo"

                                        value={this.state.dummyTwo}

                                        required="required"

                                        placeholder="Enter Dummy Two"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.dummyTwo}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Dummy Three

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handledummyThreeChange}

                                        className="form-control"

                                        name="dummyThree"

                                        value={this.state.dummyThree}

                                        required="required"

                                        placeholder="Enter Dummy Three"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.dummyThree}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Dummy Four

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handledummyFourChange}

                                        className="form-control"

                                        name="dummyFour"

                                        value={this.state.dummyFour}

                                        required="required"

                                        placeholder="Enter Dummy Four"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.dummyFour}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>

                                        Dummy Five

                                      </Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control

                                        type="text"

                                        onChange={this.handledummyFiveChange}

                                        className="form-control"

                                        name="dummyFive"

                                        value={this.state.dummyFive}

                                        required="required"

                                        placeholder="Enter Dummy Five"

                                      />

                                    </Col>

                                    <div

                                      className="errorMsg"

                                      style={{ color: "red" }}

                                    >

                                      {" "}

                                      {this.state.errors.dummyFive}{" "}

                                    </div>

                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Is Active</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handleis_activeChange}>
                                        <option defaultValue> Select Is Active </option>
                                        {this.state.yes_no.map((api, index, idx) => (
                                          <option key={index} value={api.dummyFive}> {api.dummyFive} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_active} </div>
                                  </Row><br />{/* tableContent */}

                                </Form>

                              </Row>

                            </Row>

                            <Row>

                              <Col

                                className="d-flex justify-content-end"

                                style={{ marginRight: "50px" }}

                              >

                                <Button

                                  className="button"

                                  variant="success"

                                  onClick={this.RulesdefsubmitHandler}

                                  style={{

                                    marginTop: "20px",

                                  }}

                                >

                                  Save

                                </Button>

                              </Col>

                            </Row>

                          </Container>

                        </Offcanvas.Body>

                      </Offcanvas>

                      {this.state.isEditing && (

                        // Edit Offcanvas

                        <Offcanvas

                          show={this.state.isEditing}

                          // onHide={() => this.setState({ isEditing: false })}

                          onHide={this.handleOffcanvasClose}

                          {...this.props}

                          style={{ width: "500px" }}

                          placement="end"

                          backdrop="true"

                        >

                          <Offcanvas.Header closeButton>

                            <Offcanvas.Title>Edit Rulesdef</Offcanvas.Title>

                          </Offcanvas.Header>

                          <Offcanvas.Body>

                            <Container

                              style={{ overflowY: "auto", height: "auto" }}

                            >

                              <Row className="divstyle">

                                <Row>

                                  <Form>

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Rule Group Id

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={

                                            this.handlerulegroupIdChange

                                          }

                                          className="form-control"

                                          name="rulegroupId"

                                          value={this.state.rulegroupId}

                                          required="required"

                                          placeholder="Enter Rule Group Id"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.rulegroupId}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Name

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={this.handlenameChange}

                                          className="form-control"

                                          name="name"

                                          value={this.state.name}

                                          required="required"

                                          placeholder="Enter Name"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.name}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Description

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={

                                            this.handledescriptionChange

                                          }

                                          className="form-control"

                                          name="description"

                                          value={this.state.description}

                                          required="required"

                                          placeholder="Enter Description"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.description}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Is Active

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={this.handleisActiveChange}

                                          className="form-control"

                                          name="isActive"

                                          value={this.state.isActive}

                                          required="required"

                                          placeholder="Enter Is Active"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.isActive}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Priority

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={this.handlepriorityChange}

                                          className="form-control"

                                          name="priority"

                                          value={this.state.priority}

                                          required="required"

                                          placeholder="Enter Priority"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.priority}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Execution Order

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={

                                            this.handleexecutionOrderChange

                                          }

                                          className="form-control"

                                          name="executionOrder"

                                          value={this.state.executionOrder}

                                          required="required"

                                          placeholder="Enter Execution Order"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.executionOrder}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Condition Logic Id

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={

                                            this.handleconditionlogicIdChange

                                          }

                                          className="form-control"

                                          name="conditionlogicId"

                                          value={this.state.conditionlogicId}

                                          required="required"

                                          placeholder="Enter Condition Logic Id"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {

                                          this.state.errors.conditionlogicId

                                        }{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Version

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={this.handleversionChange}

                                          className="form-control"

                                          name="version"

                                          value={this.state.version}

                                          required="required"

                                          placeholder="Enter Version"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.version}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Dummy One

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={this.handledummyOneChange}

                                          className="form-control"

                                          name="dummyOne"

                                          value={this.state.dummyOne}

                                          required="required"

                                          placeholder="Enter Dummy One"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.dummyOne}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Dummy Two

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={this.handledummyTwoChange}

                                          className="form-control"

                                          name="dummyTwo"

                                          value={this.state.dummyTwo}

                                          required="required"

                                          placeholder="Enter Dummy Two"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.dummyTwo}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Dummy Three

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={this.handledummyThreeChange}

                                          className="form-control"

                                          name="dummyThree"

                                          value={this.state.dummyThree}

                                          required="required"

                                          placeholder="Enter Dummy Three"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.dummyThree}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Dummy Four

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={this.handledummyFourChange}

                                          className="form-control"

                                          name="dummyFour"

                                          value={this.state.dummyFour}

                                          required="required"

                                          placeholder="Enter Dummy Four"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.dummyFour}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label

                                          style={{ paddingTop: "8px" }}

                                        >

                                          Dummy Five

                                        </Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control

                                          type="text"

                                          onChange={this.handledummyFiveChange}

                                          className="form-control"

                                          name="dummyFive"

                                          value={this.state.dummyFive}

                                          required="required"

                                          placeholder="Enter Dummy Five"

                                        />

                                      </Col>

                                      <div

                                        className="errorMsg"

                                        style={{ color: "red" }}

                                      >

                                        {" "}

                                        {this.state.errors.dummyFive}{" "}

                                      </div>

                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Is Active</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handleis_activeChange}>
                                          <option defaultValue> Select Is Active </option>
                                          {this.state.yes_no.map((api, index, idx) => (
                                            <option key={index} value={api.dummyFive}> {api.dummyFive} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_active} </div>
                                    </Row><br />{/* tableContent */}

                                  </Form>

                                </Row>

                              </Row>

                              <Row>

                                <Col

                                  className="d-flex justify-content-end"

                                  style={{ marginRight: "50px" }}

                                >

                                  <Button

                                    className="button"

                                    variant="success"

                                    onClick={this.RulesdefupdateHandler}

                                    style={{

                                      marginTop: "20px",

                                    }}

                                  >

                                    Update

                                  </Button>

                                </Col>

                              </Row>

                            </Container>

                          </Offcanvas.Body>

                        </Offcanvas>

                      )}

                      {/*offcanvas is over */}

                    </Col>

                  </Row>

                  <br />

                  <Row>

                    <div style={{ marginRight: "5px" }}>

                      {/* searchbar,pagination,filter */}

                      <input

                        type="text"

                        style={{ float: "left", marginBottom: "10px" }}

                        onChange={this.handleFilter}

                        placeholder="Search..."

                      />

                      <Button

                        variant="primary"

                        className="bi bi-plus "

                        style={{ float: "right", marginBottom: "10px" }}

                        onClick={this.handleOffcanvasShow}

                      >

                        New

                      </Button>

                      <DataTable

                        data={paginatedData}

                        columns={this.state.tableClms}

                        pagination

                        paginationServer

                        paginationTotalRows={

                          this.state.filteredData

                            ? this.state.filteredData.length

                            : this.state.data.length

                        }

                        onChangeRowsPerPage={this.handlePerRowsChange}

                        onChangePage={this.handlePageChange}

                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}

                        keyField="id"

                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"

                      />

                    </div>

                  </Row>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    );

  }

}
